import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { aplicarLook } from './hooks/useLook';

// Antes de montar React: si se aplicara dentro de un efecto, el primer
// cuadro se dibujaría con el look clásico y se vería un parpadeo.
aplicarLook();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
